import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';

/**
 * A layout component for grouping form fields with consistent spacing.
 * Provides optional section labels and dividers for visual separation.
 *
 * @param {string} label - Optional section label (displays as subtitle)
 * @param {number} spacing - Gap between children (MUI spacing units, default: 2)
 * @param {boolean} divider - Show divider above section (default: false)
 * @param {React.ReactNode} children - Form fields or content
 * @param {object} sx - Additional styles for the Stack container
 */
const FormSection = ({ label, spacing = 2, divider = false, children, sx = {} }) => {
  return (
    <>
      {divider && <Divider sx={{ my: 3 }} />}
      <Stack spacing={spacing} sx={sx}>
        {label && (
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              color: 'text.secondary',
              fontSize: '0.875rem',
            }}
          >
            {label}
          </Typography>
        )}
        {children}
      </Stack>
    </>
  );
};

export default FormSection;
